// SpaceDockButton (see engineering handoff, section 6): connects a Dock
// item to Background Space selection. Used for Members and Forum. The
// visual icon, selected styling, and surrounding Dock design stay under
// Plasmic control via the slot below and the `isSelected` state, which
// Studio can bind to variants.
import React, { useEffect } from "react";
import { useDesktopState } from "./DesktopStateProvider";
import styles from "./SpaceDockButton.module.css";

const SpaceDockButton = React.forwardRef(function SpaceDockButton(
  { spaceId, className, children, onSelectedChange },
  ref
) {
  const { state, actions } = useDesktopState();
  const isSelected = !!spaceId && state.currentSpace === spaceId;

  // Reports the derived value back to Studio so `isSelected` can drive
  // variants there, per the "readonly" state pattern.
  useEffect(() => {
    onSelectedChange?.(isSelected);
  }, [isSelected, onSelectedChange]);

  return (
    <button
      ref={ref}
      type="button"
      className={[styles.button, className].filter(Boolean).join(" ")}
      data-selected={isSelected}
      aria-pressed={isSelected}
      onClick={() => spaceId && actions.setSpace(spaceId)}
    >
      {children}
    </button>
  );
});

export default SpaceDockButton;
